import React from "react";
import "./Center.css";

export default ({ children }) =>
  <div className="Center">
    {children}
  </div>;



// WEBPACK FOOTER //
// ./src/components/Center.js